module.exports = __webpack_public_path__ + "media/Audio16_d.d2a58285.wav";